'use strict';

module.exports = function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
};


//////////////////
// WEBPACK FOOTER
// ../~/gatsby/~/react-router-scroll/~/scroll-behavior/~/dom-helpers/query/isWindow.js
// module id = 241
// module chunks = 0